import React, { useState, useEffect, useCallback } from 'react';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Spinner from 'ui/Spinner';
import { Icon } from 'ui';

const ChangeLanguage = () => {
  const [locale, setLocale] = useState('');
  const { data, loading, error } = useFetch(routes.SETTINGS.MY_ACCOUNT);

  useEffect(() => {
    if (data?.changeLanguage.currentLocale) {
      setLocale(data.changeLanguage.currentLocale);
    }
  }, [loading, data, error]);

  const onLanguageChange = useCallback(async () => {
    const result = await request.patchJSON(routes.SETTINGS.UPDATE_USER, {
      locale,
    });
    if (result.success) {
      const url = new URL(window.location.href);
      url.searchParams.set('locale', `${locale}`);
      window.history.replaceState(null, null, url);
      window.location.reload();
    } else {
      setLocale(data.changeLanguage.currentLocale);
    }
  }, [locale, data]);

  useEffect(() => {
    if (locale !== '' && locale !== data.changeLanguage.currentLocale) {
      onLanguageChange();
    }
  }, [locale, data, onLanguageChange]);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="Wrapper--thin" id="interface-language">
          <br />

          <h3 className="SettingsContent-heading">
            {t('settings.tab.my_account.language.title')}
          </h3>
          <hr />

          <form
            onChange={e => {
              setLocale(e.target.value);
            }}
          >
            <Icon
              name="language"
              className="fz-24 Icon--withLabel"
              alt={t('settings.tab.my_account.language.title')}
            />
            <select
              id="user_locale"
              defaultValue={data?.changeLanguage.currentLocale}
            >
              {data?.changeLanguage.availableLocales.map(option => (
                <option key={option.code} value={option.code}>
                  {option.name}
                </option>
              ))}
            </select>
            {locale !== data?.changeLanguage.currentLocale && (
              <Spinner className="ml-16" />
            )}
            <br />
          </form>
          <br />
        </div>
      )}
    </>
  );
};

export default ChangeLanguage;
